/**
 * Route che montano <SearchBar>. Unica fonte di verità condivisa da Header
 * (per mostrare/nascondere il toggle mobile) e dalle pagine stesse.
 */
const SEARCHABLE_PATH_PATTERNS: RegExp[] = [
  /^\/$/,
  /^\/escorts\/?$/,
  /^\/search\/?$/,
  /^\/landing\/[^/]+\/?$/,
  /^\/locations?\/?$/,
  /^\/location\/[^/]+\/?$/,
];

export const isSearchablePath = (pathname: string): boolean =>
  SEARCHABLE_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
